/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-14",
    versionChannel: "nightly",
    buildDate: "2025-04-14T00:07:18.629Z",
    commitHash: "dfbd90fe350ee25a3efa600b7f34014c6d49290d",
};
